// extracted by mini-css-extract-plugin
export default {"copyLink":"style_copyLink__NYeKI"};